export default {
      id: "checked-item-mark-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite-46b249.svg#checked-item-mark-usage",
      toString: function () {
        return this.url;
      }
    }